<!-- eslint-disable vue/multi-word-component-names -->
<script>
import AppCountUpTimer from '@/components/app/countUpTimer.vue';
import AppTimeShower from '@/components/app/timeShower.vue';
import CallMixin from "@/Mixins/Call/CallMixin";
import snackBar from '@/Mixins/snackBar.js';
import AlertComponent from '@/components/AlertComponent.vue';
import ShearedMixin from '@/Mixins/Shared.js';
import ShearedHelper from '@/Helpers/Shared.js';

export default {
  props: {
    myPatientPhoneNumbers: {
      type: Array,
      required: true,
      default: () => [],
    },
    myPhonePhoneNumber: {
      type: String,
      required: true,
      default: '',
    },
    myMissionId: {
      type: String,
      required: true,
      default: '',
    },
    myMissionPhoneId: {
      type: String,
      required: true,
      default: '',
    },
    cardClass: {
      type: String,
      required: true,
      default: '',
    },
    stateClass: {
      type: String,
      required: true,
      default: '',
    },
    sectionClass: {
      type: String,
      required: true,
      default: '',
    },
    code: {
      type: String,
      required: true,
      default: '',
    },
    missionDuration: {
      type: String,
      required: false,
      default: '',
    },
    phoneCurrentState: {
      type: String,
      required: true,
      default: '',
    },
    hospitalWaiting: {
      type: Object,
      required: true,
      default: () => { },
    },
    arriveToHospital: {
      type: Object,
      required: true,
      default: () => { },
    },
    patientVisit: {
      type: Object,
      required: true,
      default: () => { },
    },
    arriveToLocation: {
      type: Object,
      required: true,
      default: () => { },
    },
    moveFromStation: {
      type: Object,
      required: true,
      default: () => { },
    },
    seenDurationRecord: {
      type: Object,
      required: true,
      default: () => { },
    },
    dispatchCurrentState: {
      type: String,
      required: false,
      default: '',
    },
    show1019Icon: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  components: {
    AppCountUpTimer,
    AppTimeShower,
    AlertComponent
  },
  mixins: [CallMixin, snackBar, ShearedHelper, ShearedMixin],
  data() {
    return {
      alarm: require('@/assets/images/alarm.svg'),
      closeOnContentClick: false,
      rightClickItems: [
        { title: 'تماس با کد', icon: 'mdi-phone-log mdi-flip-h mdi-18px' },
        { title: 'تماس داخلی', icon: 'mdi-phone-log mdi-flip-h mdi-18px' },
        { title: 'تماس خارجی', icon: 'mdi-phone-forward mdi-flip-h mdi-18px' },
        { title: 'تماس با مددجو', icon: 'mdi-card-account-phone mdi-18px' },
      ],
      iternalPhoneNumber: '',
      externalPhoneNumber: '',
      showMenu: false,
      x: 0,
      y: 0,
    };
  },
  computed: {
    statesArray: function () {
      return [
        {
          ...this.seenDurationRecord,
          icon: 'mdi-cellphone',
          title: 'مشاهده ماموریت',
        },
        {
          ...this.moveFromStation,
          icon: 'mdi-car-emergency',
          title: 'حرکت از پایگاه',
        },
        {
          ...this.arriveToLocation,
          icon: 'mdi-account',
          title: 'رسیدن به محل فوریت',
        },
        {
          ...this.patientVisit,
          icon: 'mdi-account-clock',
          title: `${this.patientVisit?.time ? 'حرکت از محل ماموریت' : 'ماندگاری بر بالین'}`,
        },
        {
          ...this.arriveToHospital,
          icon: 'mdi-ambulance',
          title: 'رسیدن به مرکز درمانی',
        },
        {
          ...this.hospitalWaiting,
          icon: ' mdi-hospital-building',
          title: `${this.hospitalWaiting?.time ? 'پایان ماموریت' : 'ماندگاری در بیمارستان'}`,
        },
      ];
    },
  },
  methods: {
    rightClickAction: function (type, to) {
      this.showMenu = false;
      if (type == 'تماس با کد') {
        if (to) {
          let data = {
            missionPhoneId: this.myMissionPhoneId,
            missionId: this.myMissionId,
            to: to,
          };
          this.callToCodeFunction(data);
          this.showMenu = false;
        } else {
          this.snackText = 'کد شماره ثبت شده ای ندارد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#FF5252';
          this.snakIcon = 'mdi-information';
          return;
        }
      } else if (type == 'تماس با مددجو') {
        if (to) {
          let data = {
            missionPhoneId: this.myMissionPhoneId,
            missionId: this.myMissionId,
            to: to,
          };
          this.callToPatientFunction(data);
          this.showMenu = false;
        }
      } else if (type == 'تماس داخلی') {
        if (this.iternalPhoneNumber) {
          let data = {
            missionPhoneId: this.myMissionPhoneId,
            missionId: this.myMissionId,
            to: this.iternalPhoneNumber,
          };
          this.callToInternalFunction(data);
          this.iternalPhoneNumber = '';
          this.showMenu = false;
        } else {
          this.snackText = 'شماره تماس را وارد نمایید';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#FF5252';
          this.snakIcon = 'mdi-information';
          return;
        }
      } else if (type === 'تماس خارجی') {
        if (this.externalPhoneNumber) {
          let data = {
            missionPhoneId: this.myMissionPhoneId,
            missionId: this.myMissionId,
            to: this.externalPhoneNumber,
          };
          this.callToCustomNumber(data);
          this.externalPhoneNumber = '';
          this.showMenu = false;
        } else {
          this.snackText = 'شماره تماس را وارد نمایید';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#FF5252';
          this.snakIcon = 'mdi-information';
          return;
        }
      }
    },
    handleIconClick() {
      if (this.dispatchCurrentState?.includes('10-24')) {
        return;
      }
      this.$emit('card-click');
    },

  }
};
</script>
<template>
  <div class="pr-3">
    <v-card variant="flat" :class="[cardClass]" @click="$emit('show-information')">
      <v-card-title no-gutters class="pa-0">
        <v-row no-gutters>
          <div class="mt-1">
            <div :class="[sectionClass, 'mobile-header']">
              {{ code }}
            </div>
          </div>
          <v-row no-gutters>
            <v-icon x-small color="black">mdi-clock-time-four mdi-8px</v-icon>
            <app-count-up-timer :time="missionDuration || ''" class="mission-main-duration" />
          </v-row>
          <span :class="['mission-state-text', stateClass]">
            {{ phoneCurrentState || '-' }}
          </span>
          <v-tooltip top v-if="show1019Icon">
            <template v-slot:activator="{ on, attrs }">
              <v-icon class="mr-1 ml-1 icon1019" v-bind="attrs" v-on="on" @click.stop.prevent="handleIconClick"
                size="14" :color="dispatchCurrentState?.includes('10-24') ? '#e73a3a' : '#363636'">
                mdi-car-clock
              </v-icon>
            </template>
            <span>{{ dispatchCurrentState?.includes('10-24') ? 'کد 24-10 موقت است' : '10-24 موقت' }}</span>
          </v-tooltip>
          <v-tooltip top v-if="show1019Icon">
            <template v-slot:activator="{ on, attrs }">
              <v-icon class="mr-1 ml-1 icon1019" v-bind="attrs" v-on="on"
                @click.stop.prevent="$emit('card-click-location')" size="14">
                mdi-map-marker
              </v-icon>
            </template>
            <span>نمایش موقعیت</span>
          </v-tooltip>
          <v-menu v-model="showMenu" rounded="lg" offset-y="true" :close-on-content-click="closeOnContentClick">
            <template v-slot:activator="{ on: menu, attrs }">
              <v-tooltip top>
                <template v-slot:activator="{ on: tooltip }">
                  <v-icon size="14" class="mr-1 ml-1 icon1019" style="cursor: pointer" v-bind="attrs"
                    v-on="{ ...tooltip, ...menu }">
                    mdi-phone
                  </v-icon>
                </template>
                <span>تماس</span>
              </v-tooltip>
            </template>
            <v-list>
              <v-list-item-group>
                <v-list-item v-for="(item, index1) in rightClickItems" :key="'qq' + index1" dense>
                  <v-list-item-icon>
                    <v-icon color="darkColor">{{ item.icon }}</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content class="mr-n8 mt-n2" v-if="item.title == 'تماس داخلی'">
                    <v-list-group>
                      <template v-slot:activator>
                        <v-list-item-content>
                          <v-list-item-title>{{ item.title }}</v-list-item-title>
                        </v-list-item-content>
                      </template>
                      <v-text-field label="شماره تماس" dense v-model="iternalPhoneNumber">
                        <template v-slot:append-outer>
                          <v-btn x-small color="darkColor" dark class="py-3"
                            @click="rightClickAction(item.title, null)">
                            <v-icon color="white">mdi-phone mdi-18px mdi-flip-h</v-icon>
                          </v-btn>
                        </template>
                      </v-text-field>
                    </v-list-group>
                  </v-list-item-content>
                  <v-list-item-content class="mr-n8 mt-n2" v-if="item.title == 'تماس خارجی'">
                    <v-list-group>
                      <template v-slot:activator>
                        <v-list-item-content>
                          <v-list-item-title>{{ item.title }}</v-list-item-title>
                        </v-list-item-content>
                      </template>
                      <v-text-field placeholder="شماره تماس" dense small v-model="externalPhoneNumber">
                        <template v-slot:append-outer>
                          <v-btn x-small color="darkColor" dark class="py-3"
                            @click="rightClickAction(item.title, null)">
                            <v-icon color="white">mdi-phone-forward mdi-18px mdi-flip-h</v-icon>
                          </v-btn>
                        </template>
                      </v-text-field>
                    </v-list-group>
                  </v-list-item-content>
                  <v-list-item-content class="mr-n8 mt-n2" v-if="item.title == 'تماس با کد'">
                    <v-list-group>
                      <template v-slot:activator>
                        <v-list-item-content>
                          <v-list-item-title>{{ item.title }}</v-list-item-title>
                        </v-list-item-content>
                      </template>
                      <v-list-item @click="rightClickAction(item.title, myPhonePhoneNumber)">
                        <v-list-item-content>
                          <v-list-item-title class="mr-3">{{ myPhonePhoneNumber }}</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list-group>
                  </v-list-item-content>
                  <v-list-item-content class="mr-n8 mt-n2" v-if="item.title == 'تماس با مددجو'">
                    <v-list-group>
                      <template v-slot:activator>
                        <v-list-item-content>
                          <v-list-item-title>{{ item.title }}</v-list-item-title>
                        </v-list-item-content>
                      </template>
                      <v-list-item v-for="(sitem, index) in myPatientPhoneNumbers" :key="'c' + index"
                        @click="rightClickAction(item.title, sitem)">
                        <v-list-item-content>
                          <v-list-item-title class="mr-3">{{ sitem }}</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list-group>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-menu>
        </v-row>
      </v-card-title>
      <v-card-text no-gutters class="pa-0 px-2">
        <v-row no-gutters>
          <template v-for="({ icon, color, progressColor, time, duration, title }, index) in statesArray">
            <v-tooltip top :key="index">
              <template v-slot:activator="{ on, attrs }">
                <v-col v-on="on" v-bind="attrs">
                  <v-row>
                    <v-col cols="12" class="text-center">
                      <v-icon small :color="color">{{ icon }}</v-icon>
                    </v-col>
                    <v-col cols="12" class="mt-n5">
                      <v-row>
                        <v-spacer></v-spacer>
                        <v-col cols="11">
                          <v-progress-linear :color="progressColor" value="100" rounded height="3"></v-progress-linear>
                        </v-col>
                        <v-spacer></v-spacer>
                      </v-row>
                    </v-col>
                    <v-col cols="12" class="text-center mt-n6">
                      <h6 class="inside-times">
                        <app-time-shower v-if="time" :date="time" />
                        <app-count-up-timer v-else :time="duration" />
                      </h6>
                    </v-col>
                  </v-row>
                </v-col>
              </template>
              <span>
                {{ title }}
              </span>
            </v-tooltip>
          </template>
        </v-row>
      </v-card-text>
    </v-card>

    <alert-component ref="snackRef" :snakTimeOut="snakTimeOut" :snackColor="snackColor" :snackText="snackText"
      :snakIcon="snakIcon"></alert-component>
  </div>
</template>
<style scoped lang="scss">
.icon1019 {
  position: relative;
  top: -4px;
}

.main-card-followup {
  & {
    border-radius: 5px !important;
    height: fit-content !important;
    padding: 1rem 0 !important;
  }

  &-dashboard-red {
    background: #ffe6e2 !important;
  }

  &-dashboard-green {
    background: #d6ffe6 !important;
  }

  &-dashboard-yellow {
    background: #ffdcb4 !important;
  }

  &-dashboard-white {
    background: #f4f4f4 !important;
  }
}

.mission-state-text {
  & {
    font-size: 11px !important;
    font-weight: 600 !important;
  }

  &-red {
    color: #943a2d !important;
  }

  &-green {
    color: #15c18a !important;
  }

  &-yellow {
    color: #f57533 !important;
  }

  &-white {
    color: #616161 !important;
  }
}

.mobile-header {
  & {
    position: relative;
    font-size: 15px;
    transform: translateX(10px) !important;
    padding: 3px 10px 0px 15px;
    border-radius: 50px 3px 0px 50px;
  }

  &::after {
    content: '';
    position: absolute;
    top: 100%;
    right: 0;
    width: 0;
    height: 0;
    border: 0 solid transparent;
    border-width: 9px 0 0 11px;
    transform: rotate(270deg);
  }

  &-red {
    & {
      color: #95391f;
      background: #fff2f0;
    }

    &::after {
      border-top-color: #da6757;
    }
  }

  &-green {
    & {
      background: #f0fff6;
      color: #15c18a;
    }

    &::after {
      border-top-color: #58d876;
    }
  }

  &-yellow {
    & {
      background: #fff6ed;
      color: #f57533;
    }

    &::after {
      border-top-color: #e9881c;
    }
  }

  &-white {
    & {
      background: #ffffff;
      color: #616161;
    }

    &::after {
      border-top-color: #616161;
    }
  }
}

.mission-main-duration {
  font-size: 11px;
  color: #000000 !important;
  margin-top: 0.3rem;
}

.inside-times {
  font-size: 10px;
  font-weight: 700;
}
</style>
